import { Alert, Button } from '@mui/material'
import { type InvitationRedemptionOutcome, type InvitationRedemptionResult } from '../../../../models/peerToPeer/Invitations'

interface Props {
  result: InvitationRedemptionResult
  signedInEmail: string | null
  onSignOut: () => void
}

const MESSAGES: Record<Exclude<InvitationRedemptionOutcome, 'Accepted' | 'AlreadyAccepted' | 'EmailMismatch'>, string> = {
  Expired: 'This invitation has expired. Ask your ISD administrator to resend it.',
  Revoked: 'This invitation is no longer active. Contact your ISD administrator if you think this is a mistake.',
  NotOpen: 'This invitation isn\'t open yet. Try again once the reporting year has started.',
  NotFound: 'This invitation link isn\'t valid. If your invitation was resent, use the link in the newest email.'
}

export const InviteRedemptionNotice = ({ result, signedInEmail, onSignOut }: Props): JSX.Element | null => {
  if (result.outcome === 'Accepted' || result.outcome === 'AlreadyAccepted') return null

  if (result.outcome === 'EmailMismatch') {
    return (
      <Alert
        severity='warning'
        sx={{ mb: '20px' }}
        data-testid='p2pInviteNotice-EmailMismatch'
        action={<Button color='inherit' size='small' onClick={onSignOut}>Sign out</Button>}
      >
        You're signed in as {signedInEmail ?? 'another account'}, but this invitation was sent to {result.invitedEmail}.
        Sign out, then sign in with {result.invitedEmail}.
      </Alert>
    )
  }

  return (
    <Alert severity='warning' sx={{ mb: '20px' }} data-testid={`p2pInviteNotice-${result.outcome}`}>
      {MESSAGES[result.outcome]}
    </Alert>
  )
}
